module.exports = {
    clgl: {
        formTitle: 'Vehicle Management',
        menuItem: {
            vehicleHome: 'Vehicle Home',
            MyApproval: 'My Approvals',
            todo: 'To Do',
            done: 'Done',
            MyCar: 'My Vehicle Usage',
            MyDispatchTicket: 'My Dispatch Tickets',
            MyApplicaForm: 'My Application Forms',
            all: 'All',
            draft: 'Draft',
            progress: 'In Progress',
            Ended: 'Ended',
            VehicleGl: 'Dispatch Management',
            PendingVehicle: 'Pending Dispatch',
            SentCar: 'Dispatched Cars',
            VehicleManagement: 'Vehicle Management',
            carInfo: 'Vehicle Information',
            carInsurance: 'Vehicle Insurance',
            carAnnualReview: 'Vehicle Annual Inspection',
            carRepair: 'Vehicle Repair',
            DriverMan: 'Driver Management',
            FuelCardMan: 'Fuel Card Management',
            FuelCardInfo: 'Fuel Card Information',
            FuelCardRecharge: 'Fuel Card Recharge',
            FuelCardCon: 'Fuel Card Consumption',
            carRemind: 'Vehicle Reminders',
            InsuranceExpires: 'Insurance Expiration',
            AnnualReviewExpires: 'Annual Inspection Expiration',
            StatisticalReport: 'Statistical Reports',
            UnitVehicle: 'Unit Vehicle Usage Statistics',
            RepairCosts: 'Repair Cost Statistics',
            DriverDriving: 'Driver Trip Statistics',
            FuelCardRechargetj: 'Fuel Card Recharge Statistics',
            FuelCardContj: 'Fuel Card Consumption Statistics'
        },
        clxx: {
            fields: {
                index: 'SN',
                driverNum: 'Number of Trips',
                carNumber: 'License Plate Number',
                carType: 'Vehicle Type',
                carModel: 'Brand and Model',
                drivingLicense: 'Driving Permit',
                totalPassenger: 'Passenger Capacity',
                carRegistTime: 'Annual Inspection Valid Until',
                carSource: 'Vehicle Source',
                carDept: 'Vehicle Ownership',
                carRegistNumber: 'Registration Certificate Number',
                purchaseDate: 'Purchase Date',
                carCode: 'Chassis Number',
                payloadQuality: 'Vehicle Load Capacity',
                totalTire: 'Number of Tires',
                carEngineNo: 'Engine Number',
                carPhoto: 'Vehicle Photo'
            },
            options: {
                carSource: {
                    1: 'Free vehicles',
                    2: 'External vehicles'
                },
                draveType: {
                    1: 'With Driver', //随车司机
                    2: 'Self-Drive' //自驾
                },
                carType: {
                    1: 'Large Vehicle', //大型车
                    2: 'Medium Vehicle', //中型车
                    3: 'Small Vehicle', //小型车
                    4: 'Micro Vehicle' //微型车
                },
                flVehType: {
                    1: 'Large Vehicle', //大型车
                    2: 'Medium Vehicle', //中型车
                    3: 'Small Vehicle', //小型车
                    4: 'Micro Vehicle' //微型车
                },
                status: {
                    3: 'Delayed Use', //延期用车
                    4: 'Return' //还车
                }
            },
            carTypeFormat: '1: Large Vehicle\r\n2: Medium Vehicle\r\n3: Small Vehicle\r\n4: Micro Vehicle\r\n',
            clInfo: 'Vehicle Information'
        },
        pageBtns: {
            dispatchCar: 'DispatchCar',
            refuse: 'Refuse',
            delay: 'Delay',
            ReturnCar: 'ReturnCar',
            usingCar: 'UseCar',
            Statistics: 'Statistics',
            search: 'Search'
        },
        pcgl: {
            directgl: 'Dispatch Management',
            directVehicles: 'Direct Dispatch',
            delayCar: 'Extend Return',
            zjhCar: 'Direct Return',
            cancelCar: 'Are you sure you want to cancel the dispatch?',
            refuseCar: 'Are you sure you want to refuse the dispatch?',
            refuseCarEd: 'Dispatch refused!'
        },
        portlet: {
            seat: 'Seat(s)',
            gwap: 'Official Business Arrangement',
            AlreadyBooked: 'Already Booked',
            PendingVehicle: 'Pending Dispatch',
            SentCar: 'Dispatched',
            OutCar: 'On the Road',
            ReturnedCar: 'Returned',
            Rejected: 'Rejected',
            Cancelled: 'Cancelled',
            AccompanyDriver: 'Accompanying Driver',
            SelfDriving: 'Self-Driving',
            ArrivalLocation: 'Arrival Location',
            Apply: 'Applied on: {time}',
            status: 'Status: {status}'
        },
        tjbb: {
            fields: {
                index: 'SN',
                flCreateDept: 'Department Using Vehicle',
                totalPerson: 'Number of Passengers',
                carUseNum: 'Number of Vehicle Uses',
                driverName: 'Name',
                driverPhone: 'Phone Number',
                driverNumber: "Driver's License Number",
                drivingAge: 'Driving Years',
                driverType: "Driver's License Type",
                driverNum: 'Number of Trips'
            },
            StatisticalCycle: 'Statistical Period:',
            startTime: 'Start Date',
            endTime: 'End Date',
            UnitVehicle: 'Unit Vehicle Usage Statistics',
            dept: 'Department',
            num: 'Times',
            yearYk: 'Fuel Card Recharge Statistics for {curYear1}',
            JykTable: {
                cardNumber: 'Fuel Card Number',
                carNumber: 'License Plate Number',
                one: 'January',
                two: 'February',
                three: 'March',
                four: 'April',
                five: 'May',
                six: 'June',
                seven: 'July',
                eight: 'August',
                nine: 'September',
                ten: 'October',
                eleven: 'November',
                twelve: 'December',
                total: 'Total (Yuan)',
                Recharge: 'Recharge Fees for {curYear2} (Yuan)',
                RechargeFee: 'Fuel Card Recharge Fees',
                AnnualFuelCard: 'Fuel Card Consumption Statistics for {curYear1}'
            },
            hj: 'Total',
            totalPrice: 'Total Price',
            DriverTrip: 'Driver Trip Statistics',
            DriverName: 'Driver Name',
            frequency: 'Times',
            DriverUsage: 'Driver Vehicle Usage Statistics from {date1} to {date2}',
            sjyc: {
                contentEnter: 'Please enter content'
            },
            AnnualMain: 'Maintenance Cost Statistics for {curYear1}',
            DisDetai: 'Dispatch Details',
            isDelete: 'Are you sure you want to delete this data?'
        },
        sjxx: {
            // Driver Information
            formTitle: 'Driver Information',
            fields: {
                registNumber: 'Registration Number',
                remark: 'Remark',
                driverRegistTime: 'Driver License Registration Date',
                driverPhone: 'Contact Phone',
                driverDept: 'Department',
                carNumber: 'Link CarNumber',
                drivingAge: 'Driving Experience',
                driverType: 'Driver License Type',
                driverPhoto: 'Driver Photo',
                driverName: 'Driver Name',
                driverNumber: 'Driver Number'
            }
        },
        clbx: {
            // Vehicle Insurance Form
            formTitle: 'Vehicle Insurance Form',
            fields: {
                enterTime: 'Ins. Expiry Date',
                carNumber: 'CarNumber',
                beginTime: 'Ins. Start Date',
                aggregateCost: 'Total Cost'
            }
        },
        clfy: {
            // Vehicle Expense Registration
            formTitle: 'Vehicle Expense Registration',
            fields: {
                repairCost: 'Maintenance and Repair Cost',
                carNumber: 'CarNumber',
                driver: 'Driver',
                oilCost: 'Fuel Cost',
                kmNumber: 'Kilometers',
                parkingCost: 'Parking Fee',
                driverDept: 'Department',
                remark: 'Remark',
                washCarCost: 'Car Wash Cost',
                roadCost: 'Toll and Road Fee'
            }
        },
        clwx: {
            // Vehicle Repair
            formTitle: 'Vehicle Repair',
            fields: {
                carNumber: 'CarNumber',
                repairHandler: 'Handler',
                repairDate: 'Repair Date',
                repairAddress: 'Repair Place'
            }
        },
        clwxCost: {
            // Repair Details
            formTitle: 'Repair Details',
            fields: {
                repairMoney: 'Repair Cost',
                remark: 'Remark',
                repairType: 'Repair Details'
            }
        },
        jykcz: {
            // Fuel Card Recharge
            formTitle: 'Fuel Card Recharge',
            fields: {
                carNumber: 'CarNumber',
                rechargeAmount: 'Recharge Amount',
                rechargeHandler: 'Handler',
                cardNumber: 'Fuel Card Number',
                rechargeDate: 'Recharge Date',
                remark: 'Remark'
            }
        },
        jykxf: {
            // Fuel Card Consumption
            formTitle: 'Fuel Card Consumption',
            fields: {
                carNumber: 'CarNumber',
                cardNumber: 'Fuel Card Number',
                remark: 'Remark',
                consumeAmount: 'Current Spend',
                consumeDate: 'Consumption Date',
                consumeHandler: 'Handler'
            }
        },
        xxxm: {
            // Detailed Maintenance/Repair Items
            formTitle: 'Detailed Maintenance/Repair Items',
            fields: {
                cost: 'Estimated Cost',
                itemName: 'Item Name'
            }
        },
        clns: {
            // Vehicle Annual Inspection
            formTitle: 'Vehicle Annual Inspection',
            fields: {
                creator: 'Handler',
                inspectionDate: 'Insp. Valid. Until',
                carNumber: 'CarNumber',
                carRegistTime: 'Issuance Date',
                inspectionMoney: 'Inspection Fee',
                carType: 'Vehicle Type',
                carDept: 'Vehicle Ownership',
                carRegistNumber: 'Registration Number',
                remark: 'Remark'
            }
        },
        sendcar: {
            // View Car Dispatch
            formTitle: 'View Car Dispatch',
            fields: {
                flVehPlate: 'CarNumber',
                flEndTime: 'End Time of Usage',
                flDrvPhone: 'Driver Phone',
                flPeopleCount: 'Number of Passengers',
                flDst: 'Destination',
                flMemo: 'Reason for Usage',
                flStartTime: 'Start Time of Usage',
                returnTime: 'Actual Return Time',
                draveType: 'Driving Mode',
                flCreateDept: "User's Department",
                flCreator: 'User',
                flDrvName: 'Driver Name',
                flVehType: 'Vehicle Type'
            },
            options: {
                draveType: {
                    1: 'With Driver', //随车司机
                    2: 'Self-Drive' //自驾
                },
                flVehType: {
                    1: 'Large Vehicle', //大型车
                    2: 'Medium Vehicle', //中型车
                    3: 'Small Vehicle', //小型车
                    4: 'Micro Vehicle' //微型车
                },
                status: {
                    3: 'Delayed Use', //延期用车
                    4: 'Return' //还车
                }
            }
        },
        jyk: {
            // Fuel Card Information
            formTitle: 'Fuel Card Information',
            fields: {
                cardDate: 'Card Issuance Date',
                cardAddress: 'Card Issuance Addr',
                cardNumber: 'Fuel Card Number',
                residualAmount: 'Remaining Amount',
                remark: 'Remark',
                carNumber: 'CarNumber'
            }
        },
        ycsq: {
            // Car Usage Application_Huidong Housing and Urban-Rural Development Bureau
            formTitle: 'Car Usage Application_Huidong Housing and Urban-Rural Development Bureau',
            fields: {
                flDrvName: 'Driver Name',
                flCreator: 'Applicant',
                flEndTime: 'End Time of Usage',
                flPlanMileage: 'Estimated Mileage (KM)',
                flVehPlate: 'CarNumber',
                flSubject: 'Reason',
                flCreateDate: 'Application Date',
                flContent: 'Remark',
                flPeopleCount: 'Number of Passengers',
                flDst: 'Destination',
                flCreateDept: 'Application Department',
                flCreatorPhone: 'Contact Phone',
                flVehType: 'Vehicle Type',
                flStartTime: 'Departure Time',
                formNumber: 'Form Serial Number',
                flDeparture: 'Departure Location'
            },
            options: {
                draveType: {
                    1: 'With Driver', //随车司机
                    2: 'Self-Drive' //自驾
                },
                flVehType: {
                    1: 'Large Vehicle', //大型车
                    2: 'Medium Vehicle', //中型车
                    3: 'Small Vehicle', //小型车
                    4: 'Micro Vehicle' //微型车
                },
                apVehType: {
                    1: 'Large Vehicle', //大型车
                    2: 'Medium Vehicle', //中型车
                    3: 'Small Vehicle', //小型车
                    4: 'Micro Vehicle' //微型车
                },
                status: {
                    3: 'Delayed Use', //延期用车
                    4: 'Return' //还车
                }
            }
        },
        clbxType: {
            // Vehicle Insurance Types Table
            formTitle: 'Vehicle Insurance Types Table',
            fields: {
                companyName: 'Insurance Company',
                insuranceAmount: 'Insurance Amount (Yuan)',
                insuranceRate: 'Rate Adjustment',
                insuranceNum: 'Insurance Policy Number',
                insuranceType: 'Covered Insurance Type',
                companyPhone: 'Contact Phone',
                insuranceCost: 'Insurance Fee (Yuan)'
            }
        },
        bywxsq: {
            // Maintenance/Repair Application
            formTitle: 'Maintenance/Repair Application',
            fields: {
                totalCost: 'Total Estimated Cost',
                flContent: 'Remark',
                repairAddress: 'Repair Place',
                flCreatorPhone: 'Contact Information',
                flCreateDate: 'Application Date',
                type: 'Type',
                flCreateDept: 'Application Department',
                flSubject: 'Repair Reason',
                carNumber: 'CarNumber',
                flCreator: 'Applicant'
            }
        }
    }
}
